/* Uploadly owns storage/properties; Avante owns cart requests. Never replace either. */
(() => {
  if (window.mewoUploadlyPresentation) return;
  const config = document.querySelector('[data-mewo-uploadly-config]');
  if (!config) return;
  window.mewoUploadlyPresentation = true;
  const icon = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V3m-5 5 5-5 5 5M4 16v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4"/></svg>';
  function decorate() {
    document.querySelectorAll('.main-product [data-ph-cart-clone]').forEach(control => {
      // Uploadly supplies a clickable div while required uploads are missing.
      // Give that same provider control keyboard semantics; never submit the form here.
      if (control.tagName !== 'BUTTON') {
        control.setAttribute('role','button');
        control.setAttribute('tabindex','0');
        control.setAttribute('data-mewo-keyboard-control','true');
      }
    });
    document.querySelectorAll('.main-product [data-ph-fieldname]').forEach(field => {
      // Only the photo field observed in this store. Other provider fields stay untouched.
      if (field.getAttribute('data-ph-fieldname') !== 'Photo Upload') return;
      field.querySelectorAll('[data-open-dialog] > div[area-label][title]').forEach(remove => {
        // The provider's preview uses a div and misspells aria-label as area-label.
        // Enhance that exact node so its own removal handler remains authoritative.
        const label = remove.getAttribute('area-label');
        if (!label?.startsWith('Remove ')) return;
        remove.classList.add('mewo-uploadly-remove');
        remove.setAttribute('aria-label',label);
        remove.setAttribute('role','button');
        remove.setAttribute('tabindex','0');
        remove.setAttribute('data-mewo-keyboard-control','true');
      });
      const button = field.querySelector('.uploadcare--widget__button_type_open');
      if (!button) return;
      field.classList.add('mewo-uploadly');
      if (!button.querySelector('.mewo-uploadly-title')) {
        // Keep the same provider button node and all its event listeners.
        const nativeLabel = button.textContent.trim();
        button.setAttribute('data-mewo-original-label', nativeLabel);
        button.classList.add('mewo-uploadly-open');
        const widget = button.closest('.uploadcare--widget');
        const hasFile = widget?.getAttribute('data-status') !== 'ready';
        const label = hasFile ? nativeLabel : config.dataset.label;
        button.replaceChildren();
        button.insertAdjacentHTML('afterbegin', icon);
        const title = document.createElement('span');
        title.className = 'mewo-uploadly-title';
        title.textContent = label;
        const help = document.createElement('span');
        help.className = 'mewo-uploadly-help';
        help.textContent = config.dataset.help;
        button.append(title, help);
        // Inline !important is necessary because Uploadly uses inline !important styles.
        const styles = {width:'100%',height:'auto',padding:'16px',background:'var(--mewo-upload-background, #fafaff)',color:'#191919',border:'1.5px dashed var(--mewo-upload-border, #a7a7b8)','border-radius':'8px','font-family':'Arial, sans-serif','text-transform':'none','white-space':'normal','line-height':'1.5','font-weight':'400','margin-top':'0'};
        for (const [property,value] of Object.entries(styles)) button.style.setProperty(property,value,'important');
      }
      const changeLink = field.querySelector('.uploadcare--widget__file-name');
      if (changeLink && !changeLink.classList.contains('mewo-uploadly-change')) {
        changeLink.classList.add('mewo-uploadly-change');
        if (changeLink.tagName !== 'BUTTON' && !changeLink.hasAttribute('href')) {
          changeLink.setAttribute('role','button');
          changeLink.setAttribute('tabindex','0');
          changeLink.setAttribute('data-mewo-keyboard-control','true');
        }
        const changeStyles = {background:'transparent',color:'#191919',border:'0','border-radius':'0',padding:'8px 0','font-family':'Arial, sans-serif','font-size':'12px','font-weight':'600','text-decoration':'underline','text-align':'left','min-height':'44px'};
        for (const [property,value] of Object.entries(changeStyles)) changeLink.style.setProperty(property,value,'important');
      }
      if (!field.querySelector('.mewo-uploadly-guidance')) {
        const guidance = document.createElement('p');
        guidance.className = 'mewo-uploadly-guidance';
        guidance.textContent = config.dataset.guidance;
        field.append(guidance);
      }
    });
  }
  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {queued=false;decorate();});
  }
  // Uploadly loads asynchronously and Shopify replaces section DOM in the editor.
  const observer = new MutationObserver(schedule);
  observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',schedule);
  // Uploadly can leave the native submit button enabled after its dialog removes
  // the final file. Validate the actual outgoing form, without writing properties
  // or making a cart request. Optional upload fields and other products are untouched.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('product-form')) return;
    const field = form.closest('.main-product')?.querySelector('[data-ph-fieldname="Photo Upload"]');
    if (!field || !field.querySelector('p')?.textContent.includes('*')) return;
    const attached = [...new FormData(form)].some(([name,value]) =>
      /^properties\[Photo Upload(?: \d+)?\]$/.test(name) && typeof value === 'string' && /^https:\/\//.test(value.trim()));
    const previous = field.querySelector('.mewo-uploadly-error');
    if (attached) { previous?.remove(); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!previous) {
      const error = document.createElement('p');
      error.className = 'mewo-uploadly-error';
      error.setAttribute('role','alert');
      error.textContent = 'Please upload your photo before adding to your bag.';
      field.append(error);
    }
    field.querySelector('.uploadcare--widget__file-name, .uploadcare--widget__button_type_open')?.focus();
  }, true);
  document.addEventListener('keydown', event => {
    const control = event.target.closest?.('[data-mewo-keyboard-control]');
    if (!control || !['Enter',' '].includes(event.key) || event.repeat) return;
    event.preventDefault();
    control.click();
  });
  decorate();
})();

